/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import { takeLatestUntilApiCancel } from './merchantListing';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* paymentLinksWatcher(): Generator<
  any,
  void,
  unknown
> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_PAYMENT_LINKS_LIST);
  yield takeLatest(ActionConstants.MANAGE_PAYMENT_LINK, workerSaga);
  yield takeLatest(ActionConstants.POST_CANCEL_PAYMENT_LINK, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_ACTION,
  );
  yield takeLatest(
    ActionConstants.GET_PAYMENT_LINK_STATUS_CODE_ACTION,
    workerSaga
  );
  yield takeLatest(ActionConstants.GET_PAYMENT_LINK_UDF_ACTION, workerSaga);
  yield takeLatest(
    ActionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE,
    workerSaga
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_PAYMENT_LINK_UDF_ACTION
  );
  yield takeLatest(
    ActionConstants.CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE,
    workerSaga
  );
  yield takeLatest(ActionConstants.UPDATE_ALL_UDF_ACTION, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_ALL_EDGE_UDF_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_AVAILABLE_PAYMENT_MODE_LIST, workerSaga);
  yield takeLatest(
    ActionConstants.GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA,
    workerSaga
  );
  yield takeLatest(
    ActionConstants.POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL,
    workerSaga
  );
  yield takeLatest(
    ActionConstants.POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL,
    workerSaga
  );
  yield takeLatest(
    ActionConstants.GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA,
    workerSaga
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.FETCH_LINKED_TXN_IDS_PL);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_EDGE_MERCANT_CONFIG);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_V3_PAYMENT_LINKS_LIST
  );
}
